import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Typography, CircularProgress, Alert } from "@mui/material";
import { useValidateUserInvitation } from "../requests/userInvitations";
import { SessionStorageKey } from "../utils/constants";

// TODO: Show that they are invited to the organization in the create account page.
export const TokenInvitation = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");
  console.log(token);

  const { data: validation, isLoading, error } = useValidateUserInvitation(token);

  useEffect(() => {
    if (validation?.valid) {
      sessionStorage.setItem(SessionStorageKey.INVITATION_TOKEN, token || "");
      navigate("/new-user");
    }
  }, [validation, token, navigate]);

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (error || !validation?.valid) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" padding={2}>
        <Alert severity="error">
          This invitation link is invalid or has expired. Please contact your team's administrator.
        </Alert>
      </Box>
    );
  }

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
      <Typography>Redirecting...</Typography>
    </Box>
  );
};
